"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentProductToJSON = exports.ShipmentProductFromJSONTyped = exports.ShipmentProductFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ShipmentProductFromJSON(json) {
    return ShipmentProductFromJSONTyped(json, false);
}
exports.ShipmentProductFromJSON = ShipmentProductFromJSON;
function ShipmentProductFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sku': json['sku'],
        'quantity': json['quantity'],
        'imageUrl': !(0, runtime_1.exists)(json, 'imageUrl') ? undefined : json['imageUrl'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'name': json['name'],
        'variation': !(0, runtime_1.exists)(json, 'variation') ? undefined : json['variation'],
        'price': (0, _1.AmountFromJSON)(json['price']),
        'oldPrice': !(0, runtime_1.exists)(json, 'oldPrice') ? undefined : (0, _1.AmountFromJSON)(json['oldPrice']),
        'extra': !(0, runtime_1.exists)(json, 'extra') ? undefined : (0, _1.ProductBaseExtraFromJSON)(json['extra']),
        'articleNumber': json['articleNumber'],
        'aplus': !(0, runtime_1.exists)(json, 'aplus') ? undefined : (json['aplus'].map(_1.ShipmentProductAllOfAplusFromJSON)),
    };
}
exports.ShipmentProductFromJSONTyped = ShipmentProductFromJSONTyped;
function ShipmentProductToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sku': value.sku,
        'quantity': value.quantity,
        'imageUrl': value.imageUrl,
        'url': value.url,
        'name': value.name,
        'variation': value.variation,
        'price': (0, _1.AmountToJSON)(value.price),
        'oldPrice': (0, _1.AmountToJSON)(value.oldPrice),
        'extra': (0, _1.ProductBaseExtraToJSON)(value.extra),
        'articleNumber': value.articleNumber,
        'aplus': value.aplus === undefined ? undefined : (value.aplus.map(_1.ShipmentProductAllOfAplusToJSON)),
    };
}
exports.ShipmentProductToJSON = ShipmentProductToJSON;
//# sourceMappingURL=ShipmentProduct.js.map